import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayoutWithoutFooter from "../components/MainLayoutWithoutFooter";
import { callAPI } from "../utils/apiUtils";
import { apiUrls } from "../utils/apiUrls";
import { toast } from "react-toastify";

const PendingOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) navigate("/");
  }, [navigate]);

  
  const fetchOrders = async () => {
    try {
      setLoading(true);
      const url = `${apiUrls.PENDING_ORDERS_LISTING}?search=${search}`;
      const res = await callAPI(url, "GET");

      setOrders(res?.data?.data || []);
    } catch (err) {
      toast.error("Failed to load orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [search]);

  
  const resumeOrder = async (id) => {
    const res = await callAPI(
      `${apiUrls.RESUME_PENDING_ORDER}?id=${id}`,
      "GET"
    );

    if (res?.data?.status) {
      if (res.data.phone_order) {
        const phoneRes = await callAPI(
          apiUrls.RESUME_PHONE_ORDER,
          "GET"
        );

        if (phoneRes?.data?.status) {
          window.location.href = apiUrls.CHECKOUT_DISH;
        }
      } else {
        window.location.href = apiUrls.DINE_IN_TABLE;
      }
    }
  };

  
  const removeOrder = async (id) => {
    const res = await callAPI(
      `${apiUrls.REMOVE_PENDING_ORDER}?id=${id}`,
      "GET"
    );

    if (res?.data?.status) {
      toast.success(res.data.message);
      fetchOrders();
    }
  };

  return (
    <MainLayoutWithoutFooter>
      <div className="pageContent orderPage pb-3">
        <div className="container">
          <div className="sbRow mb-3">
            <h2 className="lgTitle mb-0">Pending Orders</h2>
          </div>

          
          <div className="row mb-4">
            <div className="col-lg-6">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          
          <div className="cardStyle">
            <div className="table-responsive">
              <table className="table tableStyle2">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Name</th>
                    <th>Date Time</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {!loading && orders.length === 0 && (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No pending orders
                      </td>
                    </tr>
                  )}

                  {orders.map((order) => (
                    <tr key={order.id}>
                      <td>{order.orderid}</td>
                      <td>
                        {order.orderUser
                          ? `${order.orderUser.firstName} ${order.orderUser.lastName}`
                          : "N/A"}
                      </td>
                      <td>{order.created_at}</td>
                      <td>
                        <span className="tblBtnCol">
                          <button
                            className="tblBtn btnOutlinePrimary"
                            onClick={() => removeOrder(order.id)}
                          >
                            Remove
                          </button>

                          <button
                            className="tblBtn btnOutlineSuccess"
                            onClick={() => resumeOrder(order.id)}
                          >
                            Resume
                          </button>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            
            <div className="text-end mt-3">
              <button
                className="btn btnSecondary"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </MainLayoutWithoutFooter>
  );
};

export default PendingOrders;
